export type OptionType = {
  value: string;
  label: string;
};

export type FormProps = {
  projectile_diameter: OptionType;
  rafter_span: OptionType;
  deck_type_thickness: OptionType;
  other_deck_type_thickness: string;
  roof_layers: OptionType;
  roof_pitch: OptionType;
};

export const PROJECTILE_DIAMETER_OPTIONS: OptionType[] = [
  { value: "0.5", label: "0.5 inches" },
  { value: "0.75", label: "0.75 inches" },
  { value: "1.0", label: "1.0 inches" },
  { value: "1.25", label: "1.25 inches" },
  { value: "1.5", label: "1.5 inches" },
  { value: "1.75", label: "1.75 inches" },
  { value: "2.0", label: "2.0 inches" },
  { value: "2.25", label: "2.25 inches" },
  { value: "2.5", label: "2.5 inches" },
];

export const RAFTER_SPAN_OPTIONS: OptionType[] = [
  { value: "12", label: "12 On Center" },
  { value: "16", label: "16 On Center" },
  { value: "20", label: "20 On Center" },
  { value: "24", label: "24 On Center" },
];

export const DECK_TYPE_OPTIONS: OptionType[] = [
  { value: 'Plywood 3/8"', label: 'Plywood 3/8"' },
  { value: 'Plywood 1/2"', label: 'Plywood 1/2"' },
  { value: 'Plywood 5/8"', label: 'Plywood 5/8"' },
  { value: 'Plywood 3/4"', label: 'Plywood 3/4"' },
  { value: 'OSB 1/2"', label: 'OSB 1/2"' },
  { value: 'OSB 7/16"', label: 'OSB 7/16"' },
  { value: 'OSB 5/8"', label: 'OSB 5/8"' },
  { value: 'OSB 3/4"', label: 'OSB 3/4"' },
  { value: 'Planks 1" x 6"', label: 'Planks 1" x 6"' },
  { value: 'Planks 1" x 8"', label: 'Planks 1" x 8"' },
  { value: 'Planks 1" x 10"', label: 'Planks 1" x 10"' },
  { value: 'Planks 1"x 12"', label: 'Planks 1"x 12"' },
  { value: "Other - Fill in Blank", label: "Other - Fill in Blank" },
];

export const ROOF_LAYERS_OPTIONS: OptionType[] = [
  { value: "1", label: "1 Layers" },
  { value: "2", label: "2 Layers" },
  { value: "3", label: "3 Layers" },
  { value: "4+", label: "4+ Layers" },
];

export const ROOF_PITCH_OPTIONS: OptionType[] = [
  { value: "3/12", label: "3/12" },
  { value: "4/12", label: "4/12" },
  { value: "5/12", label: "5/12" },
  { value: "6/12", label: "6/12" },
  { value: "7/12", label: "7/12" },
  { value: "8/12", label: "8/12" },
  { value: "9/12", label: "9/12" },
  { value: "10/12", label: "10/12" },
  { value: "11/12", label: "11/12" },
  { value: "12/12", label: "12/12" },
];
